export class NavigationRoutes {
  public static readonly GeneralErrorRoute = 'error';
  public static readonly ForbiddenRoute = 'forbidden';
  public static readonly NotFoundRoute = 'notfound';
  public static readonly UnauthorizedRoute = 'unauthorized';
  public static readonly BadBrowserRoute = 'bad-browser';
  public static readonly MaintenanceRoute = 'maintenance';
  public static readonly TermsOfUseRoute = 'terms-of-use';
  public static readonly ConfidentialityAgreementRoute = 'confidentiality-agreement';
  public static readonly ContactUsRoute = 'contact-us';
  public static readonly RecoverPassword = 'assistance';
}
